[
  {"h":"阿姨","p":"āyí","pn":"a1 yi2","e":"maternal aunt","level":3},
  {"h":"矮","p":"ǎi","pn":"ai3","e":"(of a person) short","level":3},
  {"h":"爱人","p":"àiren","pn":"ai4 ren5","e":"spouse (PRC)","level":3},
  {"h":"安静","p":"ānjìng","pn":"an1 jing4","e":"quiet","level":3},
  {"h":"安全","p":"ānquán","pn":"an1 quan2","e":"safe; secure","level":3},
  {"h":"把","p":"bǎ","pn":"ba3","e":"to hold; to grasp","level":3},
  {"h":"搬","p":"bān","pn":"ban1","e":"to move (i.e. relocate oneself)","level":3},
  {"h":"班级","p":"bānjí","pn":"ban1 ji2","e":"class (group of students)","level":3},
  {"h":"搬家","p":"bānjiā","pn":"ban1 jia1","e":"to move house; to relocate","level":3},
  {"h":"办","p":"bàn","pn":"ban4","e":"to take care of (a matter)","level":3},
  {"h":"办法","p":"bànfǎ","pn":"ban4 fa3","e":"way of handling sth; means","level":3},
  {"h":"办公室","p":"bàngōngshì","pn":"ban4 gong1 shi4","e":"office; business premises","level":3},
  {"h":"半天","p":"bàntiān","pn":"ban4 tian1","e":"half of the day","level":3},
  {"h":"帮助","p":"bāngzhù","pn":"bang1 zhu4","e":"assistance; aid","level":3},
  {"h":"饱","p":"bǎo","pn":"bao3","e":"to eat till full","level":3},
  {"h":"报纸","p":"bàozhǐ","pn":"bao4 zhi3","e":"newspaper","level":3},
  {"h":"北","p":"běi","pn":"bei3","e":"north","level":3},
  {"h":"北方","p":"běifāng","pn":"bei3 fang1","e":"north","level":3},
  {"h":"被","p":"bèi","pn":"bei4","e":"quilt","level":3},
  {"h":"笔记","p":"bǐjì","pn":"bi3 ji4","e":"to take down (in writing)","level":3},
  {"h":"比较","p":"bǐjiào","pn":"bi3 jiao4","e":"to compare","level":3},
  {"h":"笔记本","p":"bǐjìběn","pn":"bi3 ji4 ben3","e":"notebook (stationery) (","level":3},
  {"h":"比如","p":"bǐrú","pn":"bi3 ru2","e":"for example; for instance","level":3},
  {"h":"比赛","p":"bǐsài","pn":"bi3 sai4","e":"competition (sports etc)","level":3},
  {"h":"必须","p":"bìxū","pn":"bi4 xu1","e":"to have to","level":3},
  {"h":"变","p":"biàn","pn":"bian4","e":"to change","level":3},
  {"h":"遍","p":"biàn","pn":"bian4","e":"everywhere","level":3},
  {"h":"变成","p":"biànchéng","pn":"bian4 cheng2","e":"to change into","level":3},
  {"h":"变化","p":"biànhuà","pn":"bian4 hua4","e":"(intransitive) to change","level":3},
  {"h":"表演","p":"biǎoyǎn","pn":"biao3 yan3","e":"play","level":3},
  {"h":"别的","p":"biéde","pn":"bie2 de5","e":"else","level":3},
  {"h":"别人","p":"biérén","pn":"bie2 ren2","e":"other people; others","level":3},
  {"h":"宾馆","p":"bīnguǎn","pn":"bin1 guan3","e":"guesthouse","level":3},
  {"h":"冰","p":"bīng","pn":"bing1","e":"ice","level":3},
  {"h":"冰激凌","p":"bīngjīlíng","pn":"bing1 ji1 ling2","e":"ice cream","level":3},
  {"h":"冰箱","p":"bīngxiāng","pn":"bing1 xiang1","e":"refrigerator","level":3},
  {"h":"病人","p":"bìngrén","pn":"bing4 ren2","e":"sick person","level":3},
  {"h":"不但","p":"búdàn","pn":"bu2 dan4","e":"not only (... but also ...)","level":3},
  {"h":"不见","p":"bújiàn","pn":"bu2 jian4","e":"not to see","level":3},
  {"h":"不用","p":"búyòng","pn":"bu2 yong4","e":"need not","level":3},
  {"h":"不同","p":"bùtóng","pn":"bu4 tong2","e":"different","level":3},
  {"h":"不久","p":"bùjiǔ","pn":"bu4 jiu3","e":"not long (after)","level":3},
  {"h":"不行","p":"bùxíng","pn":"bu4 xing2","e":"won't do","level":3},
  {"h":"才","p":"cái","pn":"cai2","e":"(variant of 才[cai2]) just now","level":3},
  {"h":"菜单","p":"càidān","pn":"cai4 dan1","e":"menu","level":3},
  {"h":"参加","p":"cānjiā","pn":"can1 jia1","e":"to participate","level":3},
  {"h":"草","p":"cǎo","pn":"cao3","e":"grass","level":3},
  {"h":"草地","p":"cǎodì","pn":"cao3 di4","e":"lawn","level":3},
  {"h":"层","p":"céng","pn":"ceng2","e":"to pile on top of one another","level":3},
  {"h":"查","p":"chá","pn":"cha2","e":"to research","level":3},
  {"h":"差","p":"chà","pn":"cha4","e":"different","level":3},
  {"h":"差不多","p":"chàbuduō","pn":"cha4 bu5 duo1","e":"almost","level":3},
  {"h":"尝","p":"cháng","pn":"chang2","e":"to taste","level":3},
  {"h":"常","p":"cháng","pn":"chang2","e":"always","level":3},
  {"h":"常见","p":"chángjiàn","pn":"chang2 jian4","e":"commonly seen","level":3},
  {"h":"常用","p":"chángyòng","pn":"chang2 yong4","e":"in common usage","level":3},
  {"h":"常常","p":"chángcháng","pn":"chang2 chang2","e":"frequently; often","level":3},
  {"h":"衬衫","p":"chènshān","pn":"chen4 shan1","e":"shirt","level":3},
  {"h":"成绩","p":"chéngjì","pn":"cheng2 ji4","e":"achievement","level":3},
  {"h":"城市","p":"chéngshì","pn":"cheng2 shi4","e":"city; town","level":3},
  {"h":"迟到","p":"chídào","pn":"chi2 dao4","e":"to arrive late","level":3},
  {"h":"出发","p":"chūfā","pn":"chu1 fa1","e":"to set off","level":3},
  {"h":"出生","p":"chūshēng","pn":"chu1 sheng1","e":"to be born","level":3},
  {"h":"出院","p":"chūyuàn","pn":"chu1 yuan4","e":"to leave hospital","level":3},
  {"h":"初中","p":"chūzhōng","pn":"chu1 zhong1","e":"junior high school (abbr. for…","level":3},
  {"h":"除了","p":"chúle","pn":"chu2 le5","e":"apart from; besides","level":3},
  {"h":"船","p":"chuán","pn":"chuan2","e":"boat","level":3},
  {"h":"春天","p":"chūntiān","pn":"chun1 tian1","e":"spring (season)","level":3},
  {"h":"词典","p":"cídiǎn","pn":"ci2 dian3","e":"dictionary","level":3},
  {"h":"聪明","p":"cōngmíng","pn":"cong1 ming2","e":"intelligent; clever","level":3},
  {"h":"打扫","p":"dǎsǎo","pn":"da3 sao3","e":"to clean","level":3},
  {"h":"打算","p":"dǎsuàn","pn":"da3 suan4","e":"to plan","level":3},
  {"h":"大概","p":"dàgài","pn":"da4 gai4","e":"roughly","level":3},
  {"h":"大人","p":"dàren","pn":"da4 ren5","e":"adult","level":3},
  {"h":"大小","p":"dàxiǎo","pn":"da4 xiao3","e":"large and small","level":3},
  {"h":"大熊猫","p":"dàxióngmāo","pn":"da4 xiong2 mao1","e":"giant panda (Ailuropoda melanoleuca)","level":3},
  {"h":"大衣","p":"dàyī","pn":"da4 yi1","e":"overcoat","level":3},
  {"h":"带","p":"dài","pn":"dai4","e":"band","level":3},
  {"h":"担心","p":"dānxīn","pn":"dan1 xin1","e":"anxious","level":3},
  {"h":"蛋糕","p":"dàngāo","pn":"dan4 gao1","e":"cake","level":3},
  {"h":"当然","p":"dāngrán","pn":"dang1 ran2","e":"only natural","level":3},
  {"h":"到处","p":"dàochù","pn":"dao4 chu4","e":"everywhere","level":3},
  {"h":"得到","p":"dédào","pn":"de2 dao4","e":"to get; to obtain","level":3},
  {"h":"得分","p":"défēn","pn":"de2 fen1","e":"to score a point (in a competition,…","level":3},
  {"h":"的话","p":"dehuà","pn":"de5 hua4","e":"if (coming after a conditional clause)","level":3},
  {"h":"灯","p":"dēng","pn":"deng1","e":"lamp","level":3},
  {"h":"地点","p":"dìdiǎn","pn":"di4 dian3","e":"place","level":3},
  {"h":"地方","p":"dìfang","pn":"di4 fang5","e":"place; location","level":3},
  {"h":"地图","p":"dìtú","pn":"di4 tu2","e":"map","level":3},
  {"h":"电","p":"diàn","pn":"dian4","e":"lightning","level":3},
  {"h":"电梯","p":"diàntī","pn":"dian4 ti1","e":"elevator","level":3},
  {"h":"电子书","p":"diànzǐshū","pn":"dian4 zi3 shu1","e":"electronic book","level":3},
  {"h":"丢","p":"diū","pn":"diu1","e":"to lose","level":3},
  {"h":"东","p":"dōng","pn":"dong1","e":"east","level":3},
  {"h":"东北","p":"dōngběi","pn":"dong1 bei3","e":"Northeast China; Manchuria","level":3},
  {"h":"东方","p":"dōngfāng","pn":"dong1 fang1","e":"east","level":3},
  {"h":"东南","p":"dōngnán","pn":"dong1 nan2","e":"southeast","level":3},
  {"h":"冬天","p":"dōngtiān","pn":"dong1 tian1","e":"winter","level":3},
  {"h":"懂得","p":"dǒngde","pn":"dong3 de5","e":"to understand; to know","level":3},
  {"h":"动物","p":"dòngwù","pn":"dong4 wu4","e":"animal","level":3},
  {"h":"动物园","p":"dòngwùyuán","pn":"dong4 wu4 yuan2","e":"zoo","level":3},
  {"h":"短","p":"duǎn","pn":"duan3","e":"short","level":3},
  {"h":"短裤","p":"duǎnkù","pn":"duan3 ku4","e":"short pants","level":3},
  {"h":"段","p":"duàn","pn":"duan4","e":"paragraph","level":3},
  {"h":"锻炼","p":"duànliàn","pn":"duan4 lian4","e":"to toughen","level":3},
  {"h":"对话","p":"duìhuà","pn":"dui4 hua4","e":"to talk (with sb)","level":3},
  {"h":"饿","p":"è","pn":"e4","e":"hungry","level":3},
  {"h":"而且","p":"érqiě","pn":"er2 qie3","e":"(not only ...) but also","level":3},
  {"h":"耳朵","p":"ěrduo","pn":"er3 duo5","e":"ear","level":3},
  {"h":"耳机","p":"ěrjī","pn":"er3 ji1","e":"headphones","level":3},
  {"h":"发","p":"fā","pn":"fa1","e":"to send out","level":3},
  {"h":"发烧","p":"fāshāo","pn":"fa1 shao1","e":"to have a high temperature (from…","level":3},
  {"h":"发生","p":"fāshēng","pn":"fa1 sheng1","e":"to happen; to occur","level":3},
  {"h":"发现","p":"fāxiàn","pn":"fa1 xian4","e":"to notice; to become aware of","level":3},
  {"h":"发展","p":"fāzhǎn","pn":"fa1 zhan3","e":"development","level":3},
  {"h":"方便","p":"fāngbiàn","pn":"fang1 bian4","e":"convenient; suitable","level":3},
  {"h":"方便面","p":"fāngbiànmiàn","pn":"fang1 bian4 mian4","e":"instant noodles","level":3},
  {"h":"方法","p":"fāngfǎ","pn":"fang1 fa3","e":"method; way","level":3},
  {"h":"方向","p":"fāngxiàng","pn":"fang1 xiang4","e":"direction; orientation","level":3},
  {"h":"房子","p":"fángzi","pn":"fang2 zi5","e":"house","level":3},
  {"h":"放","p":"fàng","pn":"fang4","e":"to put","level":3},
  {"h":"放假","p":"fàngjià","pn":"fang4 jia4","e":"to have a holiday or vacation","level":3},
  {"h":"放心","p":"fàngxīn","pn":"fang4 xin1","e":"to feel relieved","level":3},
  {"h":"放学","p":"fàngxué","pn":"fang4 xue2","e":"to dismiss students at the end of the…","level":3},
  {"h":"分开","p":"fēnkāi","pn":"fen1 kai1","e":"to separate","level":3},
  {"h":"风","p":"fēng","pn":"feng1","e":"wind","level":3},
  {"h":"封","p":"fēng","pn":"feng1","e":"to confer","level":3},
  {"h":"夫妻","p":"fūqī","pn":"fu1 qi1","e":"husband and wife; married couple","level":3},
  {"h":"服务","p":"fúwù","pn":"fu2 wu4","e":"to serve","level":3},
  {"h":"附近","p":"fùjìn","pn":"fu4 jin4","e":"nearby; neighboring","level":3},
  {"h":"复习","p":"fùxí","pn":"fu4 xi2","e":"to review","level":3},
  {"h":"该","p":"gāi","pn":"gai1","e":"should","level":3},
  {"h":"干净","p":"gānjìng","pn":"gan1 jing4","e":"clean","level":3},
  {"h":"感兴趣","p":"gǎnxìngqù","pn":"gan3 xing4 qu4","e":"to be interested","level":3},
  {"h":"感到","p":"gǎndào","pn":"gan3 dao4","e":"to feel; to sense","level":3},
  {"h":"感冒","p":"gǎnmào","pn":"gan3 mao4","e":"to catch cold","level":3},
  {"h":"干","p":"gàn","pn":"gan4","e":"tree trunk","level":3},
  {"h":"刚","p":"gāng","pn":"gang1","e":"hard","level":3},
  {"h":"刚才","p":"gāngcái","pn":"gang1 cai2","e":"just now (variant of 剛才|刚才[gang1 cai2])","level":3},
  {"h":"刚刚","p":"gānggāng","pn":"gang1 gang1","e":"just recently","level":3},
  {"h":"高铁","p":"gāotiě","pn":"gao1 tie3","e":"high speed rail","level":3},
  {"h":"根据","p":"gēnjù","pn":"gen1 ju4","e":"according to","level":3},
  {"h":"更","p":"gèng","pn":"geng4","e":"more","level":3},
  {"h":"公斤","p":"gōngjīn","pn":"gong1 jin1","e":"kilogram (kg)","level":3},
  {"h":"公园","p":"gōngyuán","pn":"gong1 yuan2","e":"park (for public recreation)","level":3},
  {"h":"工作日","p":"gōngzuòrì","pn":"gong1 zuo4 ri4","e":"workday","level":3},
  {"h":"故事","p":"gùshi","pn":"gu4 shi5","e":"narrative; story","level":3},
  {"h":"刮","p":"guā","pn":"gua1","e":"to blow (of the wind)","level":3},
  {"h":"关","p":"guān","pn":"guan1","e":"mountain pass","level":3},
  {"h":"关机","p":"guānjī","pn":"guan1 ji1","e":"to turn off (a machine or device)","level":3},
  {"h":"关系","p":"guānxì","pn":"guan1 xi4","e":"relation","level":3},
  {"h":"关心","p":"guānxīn","pn":"guan1 xin1","e":"to be concerned about","level":3},
  {"h":"关于","p":"guānyú","pn":"guan1 yu2","e":"pertaining to","level":3},
  {"h":"关注","p":"guānzhù","pn":"guan1 zhu4","e":"to pay attention to","level":3},
  {"h":"国家","p":"guójiā","pn":"guo2 jia1","e":"country; nation","level":3},
  {"h":"过节","p":"guòjié","pn":"guo4 jie2","e":"to celebrate a festival","level":3},
  {"h":"海","p":"hǎi","pn":"hai3","e":"ocean","level":3},
  {"h":"害怕","p":"hàipà","pn":"hai4 pa4","e":"to be afraid; to be scared","level":3},
  {"h":"好多","p":"hǎoduō","pn":"hao3 duo1","e":"many","level":3},
  {"h":"好久","p":"hǎojiǔ","pn":"hao3 jiu3","e":"quite a while","level":3},
  {"h":"好像","p":"hǎoxiàng","pn":"hao3 xiang4","e":"as if","level":3},
  {"h":"号码","p":"hàomǎ","pn":"hao4 ma3","e":"number","level":3},
  {"h":"河","p":"hé","pn":"he2","e":"river (","level":3},
  {"h":"合适","p":"héshì","pn":"he2 shi4","e":"suitable; fitting","level":3},
  {"h":"黑板","p":"hēibǎn","pn":"hei1 ban3","e":"blackboard","level":3},
  {"h":"红绿灯","p":"hóng-lǜdēng","pn":"hong2 lü4 deng1","e":"traffic light","level":3},
  {"h":"后来","p":"hòulái","pn":"hou4 lai2","e":"afterwards; later","level":3},
  {"h":"后年","p":"hòunián","pn":"hou4 nian2","e":"the year after next","level":3},
  {"h":"后天","p":"hòutiān","pn":"hou4 tian1","e":"the day after tomorrow","level":3},
  {"h":"护照","p":"hùzhào","pn":"hu4 zhao4","e":"passport","level":3},
  {"h":"花园","p":"huāyuán","pn":"hua1 yuan2","e":"garden (for flowers, ornamental plants…","level":3},
  {"h":"画家","p":"huàjiā","pn":"hua4 jia1","e":"painter","level":3},
  {"h":"欢迎","p":"huānyíng","pn":"huan1 ying2","e":"to welcome","level":3},
  {"h":"环境","p":"huánjìng","pn":"huan2 jing4","e":"environment","level":3},
  {"h":"换","p":"huàn","pn":"huan4","e":"to exchange","level":3},
  {"h":"黄色","p":"huángsè","pn":"huang2 se4","e":"yellow","level":3},
  {"h":"回答","p":"huídá","pn":"hui2 da2","e":"to reply; to answer","level":3},
  {"h":"会议","p":"huìyì","pn":"hui4 yi4","e":"meeting","level":3},
  {"h":"或","p":"huò","pn":"huo4","e":"maybe","level":3},
  {"h":"或者","p":"huòzhě","pn":"huo4 zhe3","e":"or","level":3},
  {"h":"鸡","p":"jī","pn":"ji1","e":"fowl","level":3},
  {"h":"几乎","p":"jīhū","pn":"ji1 hu1","e":"almost; nearly","level":3},
  {"h":"机会","p":"jīhuì","pn":"ji1 hui4","e":"opportunity","level":3},
  {"h":"极","p":"jí","pn":"ji2","e":"extremely","level":3},
  {"h":"急","p":"jí","pn":"ji2","e":"urgent","level":3},
  {"h":"记","p":"jì","pn":"ji4","e":"to record","level":3},
  {"h":"季","p":"jì","pn":"ji4","e":"season","level":3},
  {"h":"季节","p":"jìjié","pn":"ji4 jie2","e":"time","level":3},
  {"h":"加","p":"jiā","pn":"jia1","e":"Canada (abbr. for 加拿大[Jia1 na2 da4])","level":3},
  {"h":"假期","p":"jiàqī","pn":"jia4 qi1","e":"vacation","level":3},
  {"h":"坚持","p":"jiānchí","pn":"jian1 chi2","e":"to persevere with","level":3},
  {"h":"检查","p":"jiǎnchá","pn":"jian3 cha2","e":"inspection","level":3},
  {"h":"简单","p":"jiǎndān","pn":"jian3 dan1","e":"simple; not complicated","level":3},
  {"h":"检票","p":"jiǎnpiào","pn":"jian3 piao4","e":"to inspect a ticket","level":3},
  {"h":"健康","p":"jiànkāng","pn":"jian4 kang1","e":"health","level":3},
  {"h":"见面","p":"jiànmiàn","pn":"jian4 mian4","e":"to meet; to see each other","level":3},
  {"h":"讲","p":"jiǎng","pn":"jiang3","e":"to speak","level":3},
  {"h":"角","p":"jiǎo","pn":"jiao3","e":"angle","level":3},
  {"h":"脚","p":"jiǎo","pn":"jiao3","e":"foot","level":3},
  {"h":"接","p":"jiē","pn":"jie1","e":"to receive","level":3},
  {"h":"街","p":"jiē","pn":"jie1","e":"street","level":3},
  {"h":"节","p":"jié","pn":"jie2","e":"joint; node","level":3},
  {"h":"结婚","p":"jiéhūn","pn":"jie2 hun1","e":"to marry; to get married","level":3},
  {"h":"节目","p":"jiémù","pn":"jie2 mu4","e":"(TV or radio) program; show","level":3},
  {"h":"节日","p":"jiérì","pn":"jie2 ri4","e":"holiday","level":3},
  {"h":"结束","p":"jiéshù","pn":"jie2 shu4","e":"termination","level":3},
  {"h":"解决","p":"jiějué","pn":"jie3 jue2","e":"to solve; to resolve","level":3},
  {"h":"姐妹","p":"jiěmèi","pn":"jie3 mei4","e":"sisters","level":3},
  {"h":"借","p":"jiè","pn":"jie4","e":"to borrow","level":3},
  {"h":"斤","p":"jīn","pn":"jin1","e":"catty","level":3},
  {"h":"经过","p":"jīngguò","pn":"jing1 guo4","e":"to pass","level":3},
  {"h":"经理","p":"jīnglǐ","pn":"jing1 li3","e":"manager","level":3},
  {"h":"久","p":"jiǔ","pn":"jiu3","e":"(of a period of time) long","level":3},
  {"h":"酒","p":"jiǔ","pn":"jiu3","e":"wine (esp. rice wine)","level":3},
  {"h":"旧","p":"jiù","pn":"jiu4","e":"old","level":3},
  {"h":"句","p":"jù","pn":"ju4","e":"sentence","level":3},
  {"h":"句子","p":"jùzi","pn":"ju4 zi5","e":"sentence","level":3},
  {"h":"决定","p":"juédìng","pn":"jue2 ding4","e":"to decide (to do something)","level":3},
  {"h":"卡","p":"kǎ","pn":"ka3","e":"to stop","level":3},
  {"h":"开花","p":"kāihuā","pn":"kai1 hua1","e":"to bloom; to blossom","level":3},
  {"h":"开会","p":"kāihuì","pn":"kai1 hui4","e":"to hold a meeting","level":3},
  {"h":"开机","p":"kāijī","pn":"kai1 ji1","e":"to start an engine","level":3},
  {"h":"开心","p":"kāixīn","pn":"kai1 xin1","e":"to feel happy","level":3},
  {"h":"看来","p":"kànlái","pn":"kan4 lai2","e":"apparently","level":3},
  {"h":"可","p":"kě","pn":"ke3","e":"(prefix) can; may","level":3},
  {"h":"渴","p":"kě","pn":"ke3","e":"thirsty","level":3},
  {"h":"可爱","p":"kě’ài","pn":"ke3 ai4","e":"adorable","level":3},
  {"h":"可是","p":"kěshì","pn":"ke3 shi4","e":"but; however","level":3},
  {"h":"刻","p":"kè","pn":"ke4","e":"quarter (hour)","level":3},
  {"h":"课本","p":"kèběn","pn":"ke4 ben3","e":"textbook","level":3},
  {"h":"客人","p":"kèrén","pn":"ke4 ren2","e":"visitor","level":3},
  {"h":"课文","p":"kèwén","pn":"ke4 wen2","e":"text","level":3},
  {"h":"空调","p":"kōngtiáo","pn":"kong1 tiao2","e":"air conditioning","level":3},
  {"h":"哭","p":"kū","pn":"ku1","e":"to cry; to weep","level":3},
  {"h":"筷子","p":"kuàizi","pn":"kuai4 zi5","e":"chopsticks","level":3},
  {"h":"矿泉水","p":"kuàngquánshuǐ","pn":"kuang4 quan2 shui3","e":"mineral water","level":3},
  {"h":"来自","p":"láizì","pn":"lai2 zi4","e":"to come from (a place)","level":3},
  {"h":"蓝","p":"lán","pn":"lan2","e":"blue","level":3},
  {"h":"老","p":"lǎo","pn":"lao3","e":"prefix used before the surname of a…","level":3},
  {"h":"老人","p":"lǎorén","pn":"lao3 ren2","e":"old man or woman","level":3},
  {"h":"离开","p":"líkāi","pn":"li2 kai1","e":"to depart; to leave","level":3},
  {"h":"礼物","p":"lǐwù","pn":"li3 wu4","e":"gift; present","level":3},
  {"h":"历史","p":"lìshǐ","pn":"li4 shi3","e":"history","level":3},
  {"h":"脸","p":"liǎn","pn":"lian3","e":"face","level":3},
  {"h":"练","p":"liàn","pn":"lian4","e":"to practice","level":3},
  {"h":"练习","p":"liànxí","pn":"lian4 xi2","e":"to practice","level":3},
  {"h":"凉快","p":"liángkuai","pn":"liang2 kuai5","e":"pleasantly cool (weather etc)","level":3},
  {"h":"辆","p":"liàng","pn":"liang4","e":"classifier for vehicles","level":3},
  {"h":"聊","p":"liáo","pn":"liao2","e":"(coll.) to chat","level":3},
  {"h":"聊天儿","p":"liáotiānr","pn":"liao2 tian1 r5","e":"erhua variant of 聊天[liao2 tian1]","level":3},
  {"h":"了解","p":"liǎojiě","pn":"liao3 jie3","e":"to understand","level":3},
  {"h":"邻居","p":"línjū","pn":"lin2 ju1","e":"neighbor","level":3},
  {"h":"留学","p":"liúxué","pn":"liu2 xue2","e":"to study abroad","level":3},
  {"h":"留学生","p":"liúxuéshēng","pn":"liu2 xue2 sheng1","e":"student studying abroad","level":3},
  {"h":"楼梯","p":"lóutī","pn":"lou2 ti1","e":"stair","level":3},
  {"h":"路边","p":"lùbiān","pn":"lu4 bian1","e":"curb; roadside","level":3},
  {"h":"路口","p":"lùkǒu","pn":"lu4 kou3","e":"crossing","level":3},
  {"h":"马","p":"mǎ","pn":"ma3","e":"horse","level":3},
  {"h":"马路","p":"mǎlù","pn":"ma3 lu4","e":"street","level":3},
  {"h":"马上","p":"mǎshàng","pn":"ma3 shang4","e":"at once","level":3},
  {"h":"满意","p":"mǎnyì","pn":"man3 yi4","e":"satisfied","level":3},
  {"h":"毛","p":"máo","pn":"mao2","e":"hair","level":3},
  {"h":"米","p":"mǐ","pn":"mi3","e":"uncooked rice","level":3},
  {"h":"面前","p":"miànqián","pn":"mian4 qian2","e":"in front of","level":3},
  {"h":"明白","p":"míngbai","pn":"ming2 bai5","e":"clear; obvious","level":3},
  {"h":"名单","p":"míngdān","pn":"ming2 dan1","e":"list of names","level":3},
  {"h":"名人","p":"míngrén","pn":"ming2 ren2","e":"personage","level":3},
  {"h":"南","p":"nán","pn":"nan2","e":"south","level":3},
  {"h":"难","p":"nán","pn":"nan2","e":"difficult (to...)","level":3},
  {"h":"南方","p":"nánfāng","pn":"nan2 fang1","e":"south; southern direction","level":3},
  {"h":"难过","p":"nánguò","pn":"nan2 guo4","e":"to feel sad","level":3},
  {"h":"难看","p":"nánkàn","pn":"nan2 kan4","e":"ugly","level":3},
  {"h":"男人","p":"nánrén","pn":"nan2 ren2","e":"a man","level":3},
  {"h":"男生","p":"nánshēng","pn":"nan2 sheng1","e":"schoolboy","level":3},
  {"h":"难题","p":"nántí","pn":"nan2 ti2","e":"difficult problem","level":3},
  {"h":"难听","p":"nántīng","pn":"nan2 ting1","e":"unpleasant to hear","level":3},
  {"h":"年级","p":"niánjí","pn":"nian2 ji2","e":"grade","level":3},
  {"h":"年轻","p":"niánqīng","pn":"nian2 qing1","e":"young","level":3},
  {"h":"牛","p":"niú","pn":"niu2","e":"ox","level":3},
  {"h":"努力","p":"nǔlì","pn":"nu3 li4","e":"to make an effort; to try hard","level":3},
  {"h":"女人","p":"nǚrén","pn":"nü3 ren2","e":"woman","level":3},
  {"h":"女生","p":"nǚshēng","pn":"nü3 sheng1","e":"schoolgirl","level":3},
  {"h":"爬","p":"pá","pn":"pa2","e":"to crawl","level":3},
  {"h":"怕","p":"pà","pn":"pa4","e":"to be afraid","level":3},
  {"h":"拍照","p":"pāizhào","pn":"pai1 zhao4","e":"to take a picture","level":3},
  {"h":"盘子","p":"pánzi","pn":"pan2 zi5","e":"tray","level":3},
  {"h":"胖","p":"pàng","pn":"pang4","e":"fat","level":3},
  {"h":"啤酒","p":"píjiǔ","pn":"pi2 jiu3","e":"beer (loanword)","level":3},
  {"h":"平时","p":"píngshí","pn":"ping2 shi2","e":"ordinarily","level":3},
  {"h":"瓶子","p":"píngzi","pn":"ping2 zi5","e":"bottle","level":3},
  {"h":"骑","p":"qí","pn":"qi2","e":"to sit astride","level":3},
  {"h":"奇怪","p":"qíguài","pn":"qi2 guai4","e":"strange","level":3},
  {"h":"其实","p":"qíshí","pn":"qi2 shi2","e":"actually; in fact","level":3},
  {"h":"其他","p":"qítā","pn":"qi2 ta1","e":"other","level":3},
  {"h":"起","p":"qǐ","pn":"qi3","e":"to rise","level":3},
  {"h":"起飞","p":"qǐfēi","pn":"qi3 fei1","e":"(of an aircraft or rocket) to take off","level":3},
  {"h":"汽车","p":"qìchē","pn":"qi4 che1","e":"car","level":3},
  {"h":"铅笔","p":"qiānbǐ","pn":"qian1 bi3","e":"(lead) pencil","level":3},
  {"h":"前年","p":"qiánnián","pn":"qian2 nian2","e":"the year before last","level":3},
  {"h":"前天","p":"qiántiān","pn":"qian2 tian1","e":"the day before yesterday","level":3},
  {"h":"清楚","p":"qīngchu","pn":"qing1 chu5","e":"clear","level":3},
  {"h":"请假","p":"qǐngjià","pn":"qing3 jia4","e":"to request leave of absence","level":3},
  {"h":"请客","p":"qǐngkè","pn":"qing3 ke4","e":"to give a dinner party","level":3},
  {"h":"秋天","p":"qiūtiān","pn":"qiu1 tian1","e":"autumn","level":3},
  {"h":"球场","p":"qiúchǎng","pn":"qiu2 chang3","e":"stadium","level":3},
  {"h":"裙子","p":"qúnzi","pn":"qun2 zi5","e":"skirt","level":3},
  {"h":"然后","p":"ránhòu","pn":"ran2 hou4","e":"then; after that","level":3},
  {"h":"热情","p":"rèqíng","pn":"re4 qing2","e":"cordial","level":3},
  {"h":"认得","p":"rènde","pn":"ren4 de5","e":"to recognize","level":3},
  {"h":"认为","p":"rènwéi","pn":"ren4 wei2","e":"to believe; to think","level":3},
  {"h":"认真","p":"rènzhēn","pn":"ren4 zhen1","e":"conscientious","level":3},
  {"h":"容易","p":"róngyì","pn":"rong2 yi4","e":"easy; straightforward","level":3},
  {"h":"如果","p":"rúguǒ","pn":"ru2 guo3","e":"if","level":3},
  {"h":"伞","p":"sǎn","pn":"san3","e":"damask silk","level":3},
  {"h":"扫","p":"sǎo","pn":"sao3","e":"to sweep (with a brush or broom)","level":3},
  {"h":"沙发","p":"shāfā","pn":"sha1 fa1","e":"(loanword) sofa (","level":3},
  {"h":"山","p":"shān","pn":"shan1","e":"mountain; hill (","level":3},
  {"h":"上衣","p":"shàngyī","pn":"shang4 yi1","e":"jacket","level":3},
  {"h":"勺子","p":"sháozi","pn":"shao2 zi5","e":"spoon; ladle","level":3},
  {"h":"身边","p":"shēnbiān","pn":"shen1 bian1","e":"at one's side","level":3},
  {"h":"身高","p":"shēngāo","pn":"shen1 gao1","e":"(a person's) height","level":3},
  {"h":"声","p":"shēng","pn":"sheng1","e":"sound","level":3},
  {"h":"生活","p":"shēnghuó","pn":"sheng1 huo2","e":"to live","level":3},
  {"h":"生气","p":"shēngqì","pn":"sheng1 qi4","e":"to get angry; to be furious","level":3},
  {"h":"声音","p":"shēngyīn","pn":"sheng1 yin1","e":"voice","level":3},
  {"h":"市","p":"shì","pn":"shi4","e":"market","level":3},
  {"h":"试","p":"shì","pn":"shi4","e":"to test","level":3},
  {"h":"室","p":"shì","pn":"shi4","e":"room","level":3},
  {"h":"世界","p":"shìjiè","pn":"shi4 jie4","e":"world","level":3},
  {"h":"收","p":"shōu","pn":"shou1","e":"to receive","level":3},
  {"h":"收到","p":"shōudào","pn":"shou1 dao4","e":"to receive","level":3},
  {"h":"受","p":"shòu","pn":"shou4","e":"to receive","level":3},
  {"h":"瘦","p":"shòu","pn":"shou4","e":"thin","level":3},
  {"h":"受到","p":"shòudào","pn":"shou4 dao4","e":"to receive (praise, an education,…","level":3},
  {"h":"叔叔","p":"shūshu","pn":"shu1 shu5","e":"father's younger brother","level":3},
  {"h":"树","p":"shù","pn":"shu4","e":"tree","level":3},
  {"h":"数学","p":"shùxué","pn":"shu4 xue2","e":"mathematics","level":3},
  {"h":"刷","p":"shuā","pn":"shua1","e":"a brush","level":3},
  {"h":"双","p":"shuāng","pn":"shuang1","e":"two","level":3},
  {"h":"水平","p":"shuǐpíng","pn":"shui3 ping2","e":"horizontal; level","level":3},
  {"h":"司机","p":"sījī","pn":"si1 ji1","e":"chauffeur; driver","level":3},
  {"h":"四季","p":"sìjì","pn":"si4 ji4","e":"four seasons, namely: spring 春[chun1],…","level":3},
  {"h":"太阳","p":"tàiyáng","pn":"tai4 yang2","e":"sun","level":3},
  {"h":"糖","p":"táng","pn":"tang2","e":"sugar","level":3},
  {"h":"特别","p":"tèbié","pn":"te4 bie2","e":"unusual; special","level":3},
  {"h":"提高","p":"tígāo","pn":"ti2 gao1","e":"to raise","level":3},
  {"h":"体育","p":"tǐyù","pn":"ti3 yu4","e":"sports","level":3},
  {"h":"体育馆","p":"tǐyùguǎn","pn":"ti3 yu4 guan3","e":"gym","level":3},
  {"h":"甜","p":"tián","pn":"tian2","e":"sweet","level":3},
  {"h":"跳","p":"tiào","pn":"tiao4","e":"to jump","level":3},
  {"h":"听说","p":"tīngshuō","pn":"ting1 shuo1","e":"to hear (sth said)","level":3},
  {"h":"挺","p":"tǐng","pn":"ting3","e":"straight","level":3},
  {"h":"同事","p":"tóngshì","pn":"tong2 shi4","e":"colleague; co-worker","level":3},
  {"h":"同意","p":"tóngyì","pn":"tong2 yi4","e":"to agree","level":3},
  {"h":"头发","p":"tóufa","pn":"tou2 fa5","e":"hair (on the head)","level":3},
  {"h":"突然","p":"tūrán","pn":"tu1 ran2","e":"sudden; abrupt","level":3},
  {"h":"图书馆","p":"túshūguǎn","pn":"tu2 shu1 guan3","e":"library","level":3},
  {"h":"腿","p":"tuǐ","pn":"tui3","e":"hip bone","level":3},
  {"h":"外地","p":"wàidì","pn":"wai4 di4","e":"parts of the country other than where…","level":3},
  {"h":"外卖","p":"wàimài","pn":"wai4 mai4","e":"(of a restaurant) to provide a takeout…","level":3},
  {"h":"外语","p":"wàiyǔ","pn":"wai4 yu3","e":"foreign language","level":3},
  {"h":"完成","p":"wánchéng","pn":"wan2 cheng2","e":"to complete; to accomplish","level":3},
  {"h":"碗","p":"wǎn","pn":"wan3","e":"bowl","level":3},
  {"h":"晚点","p":"wǎndiǎn","pn":"wan3 dian3","e":"(of trains etc) late","level":3},
  {"h":"晚会","p":"wǎnhuì","pn":"wan3 hui4","e":"evening party","level":3},
  {"h":"网球","p":"wǎngqiú","pn":"wang3 qiu2","e":"tennis","level":3},
  {"h":"网站","p":"wǎngzhàn","pn":"wang3 zhan4","e":"website","level":3},
  {"h":"忘记","p":"wàngjì","pn":"wang4 ji4","e":"to forget","level":3},
  {"h":"为","p":"wèi","pn":"wei4","e":"because of","level":3},
  {"h":"为了","p":"wèile","pn":"wei4 le5","e":"for; for the purpose of","level":3},
  {"h":"卫生间","p":"wèishēngjiān","pn":"wei4 sheng1 jian1","e":"bathroom","level":3},
  {"h":"文化","p":"wénhuà","pn":"wen2 hua4","e":"culture","level":3},
  {"h":"屋子","p":"wūzi","pn":"wu1 zi5","e":"house","level":3},
  {"h":"西","p":"xī","pn":"xi1","e":"the West","level":3},
  {"h":"西北","p":"xīběi","pn":"xi1 bei3","e":"Northwest China (Shaanxi, Gansu,…","level":3},
  {"h":"西方","p":"xīfāng","pn":"xi1 fang1","e":"the West","level":3},
  {"h":"西瓜","p":"xīguā","pn":"xi1 gua1","e":"watermelon","level":3},
  {"h":"西南","p":"xīnán","pn":"xi1 nan2","e":"southwest","level":3},
  {"h":"习惯","p":"xíguàn","pn":"xi2 guan4","e":"habit","level":3},
  {"h":"喜爱","p":"xǐ’ài","pn":"xi3 ai4","e":"to like","level":3},
  {"h":"洗衣机","p":"xǐyījī","pn":"xi3 yi1 ji1","e":"washing machine; washer","level":3},
  {"h":"洗澡","p":"xǐzǎo","pn":"xi3 zao3","e":"to bathe","level":3},
  {"h":"夏天","p":"xiàtiān","pn":"xia4 tian1","e":"summer","level":3},
  {"h":"先","p":"xiān","pn":"xian1","e":"beforehand; first","level":3},
  {"h":"香蕉","p":"xiāngjiāo","pn":"xiang1 jiao1","e":"banana","level":3},
  {"h":"相信","p":"xiāngxìn","pn":"xiang1 xin4","e":"to believe; to be convinced","level":3},
  {"h":"箱子","p":"xiāngzi","pn":"xiang1 zi5","e":"suitcase","level":3},
  {"h":"向","p":"xiàng","pn":"xiang4","e":"to tend toward","level":3},
  {"h":"像","p":"xiàng","pn":"xiang4","e":"to resemble","level":3},
  {"h":"相机","p":"xiàngjī","pn":"xiang4 ji1","e":"camera (abbr. for 照相機|照相机[zhao4 xiang4…","level":3},
  {"h":"小区","p":"xiǎoqū","pn":"xiao3 qu1","e":"housing estate; community","level":3},
  {"h":"小心","p":"xiǎoxīn","pn":"xiao3 xin1","e":"to be careful","level":3},
  {"h":"校园","p":"xiàoyuán","pn":"xiao4 yuan2","e":"campus","level":3},
  {"h":"校长","p":"xiàozhǎng","pn":"xiao4 zhang3","e":"(college, university) president","level":3},
  {"h":"鞋","p":"xié","pn":"xie2","e":"shoe","level":3},
  {"h":"心里","p":"xīnlǐ","pn":"xin1 li3","e":"chest","level":3},
  {"h":"新年","p":"xīnnián","pn":"xin1 nian2","e":"New Year","level":3},
  {"h":"新闻","p":"xīnwén","pn":"xin1 wen2","e":"news","level":3},
  {"h":"新鲜","p":"xīnxiān","pn":"xin1 xian1","e":"fresh (experience, food etc)","level":3},
  {"h":"信","p":"xìn","pn":"xin4","e":"letter","level":3},
  {"h":"信用卡","p":"xìnyòngkǎ","pn":"xin4 yong4 ka3","e":"credit card","level":3},
  {"h":"行","p":"xíng","pn":"xing2","e":"to walk; to go","level":3},
  {"h":"行李","p":"xíngli","pn":"xing2 li5","e":"luggage","level":3},
  {"h":"兴趣","p":"xìngqù","pn":"xing4 qu4","e":"interest (desire to know about sth)","level":3},
  {"h":"休假","p":"xiūjià","pn":"xiu1 jia4","e":"to go on vacation","level":3},
  {"h":"需要","p":"xūyào","pn":"xu1 yao4","e":"to need; to want","level":3},
  {"h":"选","p":"xuǎn","pn":"xuan3","e":"to choose","level":3},
  {"h":"选择","p":"xuǎnzé","pn":"xuan3 ze2","e":"to select; to pick","level":3},
  {"h":"学期","p":"xuéqī","pn":"xue2 qi1","e":"term","level":3},
  {"h":"牙","p":"yá","pn":"ya2","e":"tooth","level":3},
  {"h":"牙刷","p":"yáshuā","pn":"ya2 shua1","e":"toothbrush","level":3},
  {"h":"羊","p":"yáng","pn":"yang2","e":"sheep; goat","level":3},
  {"h":"养","p":"yǎng","pn":"yang3","e":"to raise (animals)","level":3},
  {"h":"要求","p":"yāoqiú","pn":"yao1 qiu2","e":"to request","level":3},
  {"h":"页","p":"yè","pn":"ye4","e":"page","level":3},
  {"h":"一定","p":"yídìng","pn":"yi2 ding4","e":"surely","level":3},
  {"h":"一共","p":"yígòng","pn":"yi2 gong4","e":"in total; altogether","level":3},
  {"h":"一块儿","p":"yíkuàir","pn":"yi2 kuai4 r5","e":"erhua variant of 一塊|一块[yi1 kuai4]","level":3},
  {"h":"一样","p":"yíyàng","pn":"yi2 yang4","e":"same","level":3},
  {"h":"以后","p":"yǐhòu","pn":"yi3 hou4","e":"after","level":3},
  {"h":"以前","p":"yǐqián","pn":"yi3 qian2","e":"before","level":3},
  {"h":"以上","p":"yǐshàng","pn":"yi3 shang4","e":"that level or higher","level":3},
  {"h":"以外","p":"yǐwài","pn":"yi3 wai4","e":"apart from","level":3},
  {"h":"以为","p":"yǐwéi","pn":"yi3 wei2","e":"to think","level":3},
  {"h":"以下","p":"yǐxià","pn":"yi3 xia4","e":"that level or lower","level":3},
  {"h":"一般","p":"yìbān","pn":"yi4 ban1","e":"same","level":3},
  {"h":"一边","p":"yìbiān","pn":"yi4 bian1","e":"one side","level":3},
  {"h":"一直","p":"yìzhí","pn":"yi4 zhi2","e":"straight (in a straight line)","level":3},
  {"h":"音乐","p":"yīnyuè","pn":"yin1 yue4","e":"music","level":3},
  {"h":"银行","p":"yínháng","pn":"yin2 hang2","e":"bank","level":3},
  {"h":"银行卡","p":"yínhángkǎ","pn":"yin2 hang2 ka3","e":"bank card","level":3},
  {"h":"饮料","p":"yǐnliào","pn":"yin3 liao4","e":"drink","level":3},
  {"h":"应该","p":"yīnggāi","pn":"ying1 gai1","e":"ought to; should","level":3},
  {"h":"影响","p":"yǐngxiǎng","pn":"ying3 xiang3","e":"influence","level":3},
  {"h":"用","p":"yòng","pn":"yong4","e":"to use; to make use of","level":3},
  {"h":"邮件","p":"yóujiàn","pn":"you2 jian4","e":"mail","level":3},
  {"h":"游客","p":"yóukè","pn":"you2 ke4","e":"traveler; tourist","level":3},
  {"h":"游戏","p":"yóuxì","pn":"you2 xi4","e":"game (","level":3},
  {"h":"邮箱","p":"yóuxiāng","pn":"you2 xiang1","e":"mailbox","level":3},
  {"h":"有关","p":"yǒuguān","pn":"you3 guan1","e":"to have sth to do with","level":3},
  {"h":"有名","p":"yǒumíng","pn":"you3 ming2","e":"famous","level":3},
  {"h":"有用","p":"yǒuyòng","pn":"you3 yong4","e":"useful","level":3},
  {"h":"又","p":"yòu","pn":"you4","e":"(once) again","level":3},
  {"h":"羽毛球","p":"yǔmáoqiú","pn":"yu3 mao2 qiu2","e":"badminton","level":3},
  {"h":"语言","p":"yǔyán","pn":"yu3 yan2","e":"language","level":3},
  {"h":"雨衣","p":"yǔyī","pn":"yu3 yi1","e":"raincoat","level":3},
  {"h":"遇到","p":"yùdào","pn":"yu4 dao4","e":"to meet; to run into","level":3},
  {"h":"遇见","p":"yùjiàn","pn":"yu4 jian4","e":"to meet","level":3},
  {"h":"园","p":"yuán","pn":"yuan2","e":"land used for growing plants","level":3},
  {"h":"员","p":"yuán","pn":"yuan2","e":"person engaged in a certain field of…","level":3},
  {"h":"愿意","p":"yuànyì","pn":"yuan4 yi4","e":"to wish","level":3},
  {"h":"越","p":"yuè","pn":"yue4","e":"generic word for peoples or states of…","level":3},
  {"h":"月亮","p":"yuèliang","pn":"yue4 liang5","e":"the moon","level":3},
  {"h":"运动会","p":"yùndònghuì","pn":"yun4 dong4 hui4","e":"sports competition","level":3},
  {"h":"运动员","p":"yùndòngyuán","pn":"yun4 dong4 yuan2","e":"athlete","level":3},
  {"h":"咱们","p":"zánmen","pn":"zan2 men5","e":"we or us (including both the speaker…","level":3},
  {"h":"脏","p":"zāng","pn":"zang1","e":"dirty","level":3},
  {"h":"怎么办","p":"zěnmebàn","pn":"zen3 me5 ban4","e":"what's to be done","level":3},
  {"h":"怎样","p":"zěnyàng","pn":"zen3 yang4","e":"how","level":3},
  {"h":"张","p":"zhāng","pn":"zhang1","e":"to open up","level":3},
  {"h":"着急","p":"zháojí","pn":"zhao2 ji2","e":"to worry; to feel anxious","level":3},
  {"h":"照","p":"zhào","pn":"zhao4","e":"according to","level":3},
  {"h":"照顾","p":"zhàogù","pn":"zhao4 gu4","e":"to take care of","level":3},
  {"h":"照片","p":"zhàopiàn","pn":"zhao4 pian4","e":"photograph","level":3},
  {"h":"照相","p":"zhàoxiàng","pn":"zhao4 xiang4","e":"to take a photograph","level":3},
  {"h":"直到","p":"zhídào","pn":"zhi2 dao4","e":"until","level":3},
  {"h":"纸","p":"zhǐ","pn":"zhi3","e":"paper (","level":3},
  {"h":"只能","p":"zhǐnéng","pn":"zhi3 neng2","e":"can only","level":3},
  {"h":"只是","p":"zhǐshì","pn":"zhi3 shi4","e":"merely; only","level":3},
  {"h":"只要","p":"zhǐyào","pn":"zhi3 yao4","e":"so long as; provided","level":3},
  {"h":"只有","p":"zhǐyǒu","pn":"zhi3 you3","e":"only have ...; there is only ...","level":3},
  {"h":"中","p":"zhōng","pn":"zhong1","e":"China; Chinese","level":3},
  {"h":"中间","p":"zhōngjiān","pn":"zhong1 jian1","e":"the middle; the inside","level":3},
  {"h":"终于","p":"zhōngyú","pn":"zhong1 yu2","e":"at last","level":3},
  {"h":"种","p":"zhǒng","pn":"zhong3","e":"seed","level":3},
  {"h":"重要","p":"zhòngyào","pn":"zhong4 yao4","e":"important; significant","level":3},
  {"h":"周末","p":"zhōumò","pn":"zhou1 mo4","e":"weekend","level":3},
  {"h":"主要","p":"zhǔyào","pn":"zhu3 yao4","e":"main; principal","level":3},
  {"h":"注意","p":"zhùyì","pn":"zhu4 yi4","e":"to take note of","level":3},
  {"h":"住院","p":"zhùyuàn","pn":"zhu4 yuan4","e":"to stay in hospital","level":3},
  {"h":"字典","p":"zìdiǎn","pn":"zi4 dian3","e":"Chinese character dictionary…","level":3},
  {"h":"自行车","p":"zìxíngchē","pn":"zi4 xing2 che1","e":"bicycle; bike","level":3},
  {"h":"子","p":"zi","pn":"zi5","e":"noun suffix, as in 椅子[yi3 zi5] \"chair\"","level":3},
  {"h":"总","p":"zǒng","pn":"zong3","e":"general; overall","level":3},
  {"h":"总是","p":"zǒngshì","pn":"zong3 shi4","e":"always","level":3},
  {"h":"嘴","p":"zuǐ","pn":"zui3","e":"mouth","level":3},
  {"h":"最好","p":"zuìhǎo","pn":"zui4 hao3","e":"best","level":3},
  {"h":"最后","p":"zuìhòu","pn":"zui4 hou4","e":"final; last","level":3},
  {"h":"最近","p":"zuìjìn","pn":"zui4 jin4","e":"recently","level":3},
  {"h":"做客","p":"zuòkè","pn":"zuo4 ke4","e":"to be a guest or visitor","level":3},
  {"h":"作业","p":"zuòyè","pn":"zuo4 ye4","e":"school assignment","level":3}
]
